import moment from 'moment'

import type {Build, NormalizedBuild} from '../types'

const getStartDate = (build: NormalizedBuild | Build, useFinishedForCompositeBuilds: boolean) =>
  useFinishedForCompositeBuilds && build.composite === true ? build.finishDate : build.startDate

export const sortByStarted =
  (
    useFinishedForCompositeBuilds = false,
  ): ((arg0: NormalizedBuild | Build, arg1: NormalizedBuild | Build) => number) =>
  (buildA, buildB) => {
    const startA = getStartDate(buildA, useFinishedForCompositeBuilds)
    const startB = getStartDate(buildB, useFinishedForCompositeBuilds)

    if (startA != null) {
      if (startB == null || moment(startA).isBefore(startB)) {
        return -1
      }

      if (moment(startB).isBefore(startA)) {
        return 1
      }

      return 0
    }

    if (startB != null) {
      return 1
    }

    if (buildA.queuePosition != null) {
      if (buildB.queuePosition == null) {
        return -1
      }

      return buildA.queuePosition - buildB.queuePosition
    }

    if (buildB.queuePosition != null) {
      return 1
    }

    return 0
  }

const startedBefore = (
  buildA: NormalizedBuild | Build,
  buildB: NormalizedBuild | Build,
  useFinishedForCompositeBuilds = false,
): boolean => sortByStarted(useFinishedForCompositeBuilds)(buildA, buildB) < 0

export default startedBefore
